module.exports = __webpack_public_path__ + "static/shoosuva-ba08ee4a3ba71ce20dcd569b0ac832a7.jpeg";